import React, { useState, useEffect } from "react";
import Cookies from "js-cookie"
const cookie = Cookies;
import "./style.css";
import "../node_modules/nprogress/nprogress.css";
import "../node_modules/nprogress/nprogress.js";
import { mailbotsAdminBrowser, setAccessToken } from "./lib/utils";
import queryString from "query-string";
import { message as antMessage } from "antd";
import { useNavigate } from "react-router-dom";
import nprogress from "nprogress";
import Loading from "./Loading";
import { logger } from "./lib/Logger";

const GetAuthToken = ({ reloadUser }) => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  // Handle redirect logic
  const handleRedirect = async () => {
    const params = queryString.parse(window.location.search);

    // If we're mid-merging accounts, pause automatic redirects
    // They will be picked up after new emails are confirmed
    if (
      window.location.pathname.startsWith("/merge-accounts") ||
      window.location.pathname.startsWith("/settings")
    ) {
      return false;
    }

    let redirect;
    if (cookie.get("mailbotsRedirect")) {
      redirect = cookie.get("mailbotsRedirect");
      cookie.remove("mailbotsRedirect");
    } else if (params.redirect) {
      redirect = params.redirect;
    } else {
      redirect = "/skills";
    }

    async function noMailBotsInstalled() {
      try {
        nprogress.start();
        const extRes = await mailbotsAdminBrowser.getMailBots({ installed: 1 });
        nprogress.done();
        return (
          !Array.isArray(extRes.mailbots) ||
          (Array.isArray(extRes.mailbots) && extRes.mailbots.length === 0)
        );
      } catch (e) {
        nprogress.done();
        console.log(e);
        antMessage.error(e.message);
      }
    }

    // If they are a new user, show welcome dialog.
    // if (await noMailBotsInstalled()) {
    //   redirect += "?welcome=1";
    // }

    // Verify redirect is to a trusted url
    // TODO: Should there by any URL redirect protection?
    // if (
    //   (!redirect.includes("mailbots") && !redirect.includes("register")) ||
    //   redirect.includes("//")
    // ) {
    //   console.error("Redirect to an unauthorized page detected: ", redirect);
    //   return;
    // }

    navigate(redirect);
    return;
  };

  useEffect(() => {
    const params = queryString.parse(window.location.search);
    const code = params.code;
    const errorDesc = params.error_description;
    const redirect = params.redirect;
    if (redirect) cookie.set("mailbotsRedirect", redirect); // Invoked in GetAuthToken.js

    if (errorDesc) {
      setError(errorDesc);
      return;
    }

    const getToken = async () => {
      try {
        nprogress.start();
        const res = await mailbotsAdminBrowser.getAccessToken(code);
        nprogress.done();
        const userRes = await reloadUser({
          accessToken: res.mailbotsToken
        });
        handleRedirect();
      } catch (err) {
        logger.log("/auth/callback error", {
          level: "warn",
          data: { error_str: err.message }
        });
        nprogress.done();
        setError(
          `⚠️ Sorry, something went wrong while logging you in (${err.message}). Please try again. If this keeps happing, contact help@humans.fut.io for help.`
        );
        console.log(err);
      }
    };

    getToken();
  }, []);

  if (error) {
    return (
      <div style={{ padding: 30 }}>
        <div className="alert alert-grey">{error}</div>
      </div>
    );
  } else return <Loading />;
};

export default GetAuthToken;
